import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'Carrier Sharing wallet warning modal title',
    defaultMessage: 'Carrier Setup Required',
    id: 'yDy8ps',
  },
  okButton: {
    description: 'Carrier Sharing wallet warning modal ok button text',
    defaultMessage: 'Get Started',
    id: 'Nc+Xi+',
  },
  cancel: {
    description: 'Carrier Sharing wallet warning modal cancel button text',
    defaultMessage: 'Cancel',
    id: '3aoVmQ',
  },
  message: {
    description: 'Carrier Sharing wallet warning modal message',
    defaultMessage:
      'You are attempting to share your ShipStation Carrier account with a fulfillment provider. To do so, you must first set up your ShipStation Carrier account, including providing payment details.',
    id: 'N74BMN',
  },
});
